import Policy from './Policy/Policy';
import PolicySummaryForm from './PolicySummaryForm';

export const PolicySummaryForms = {
  Policy,
  Form: PolicySummaryForm
};
